import moment from 'moment'
export const helpersMixins = {
  methods: {
    prettyDate (date) {
      return moment(date).fromNow()
    },
    detailedDate (date) {
      return moment(date).format('lll')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/helpersMixins.js